// DevPreviewConfirmModal.js — HITL avant ouverture preview application

import React from 'react';
import { Monitor, AlertTriangle } from 'lucide-react';
import './devCockpit.css';

export default function DevPreviewConfirmModal({ onConfirm, onCancel }) {
    return (
        <div className="dev-modal-overlay">
            <div className="dev-modal">
                <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
                    <Monitor size={20} color="#fbbf24" />
                    <h3>Preview application</h3>
                </div>
                <p>
                    Affiche le build statique CRA depuis votre sandbox git.
                    Le code exécuté est celui que vous avez compilé localement dans le terminal.
                </p>
                <p style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 8 }}>
                    <AlertTriangle size={12} style={{ display: 'inline', verticalAlign: -2, marginRight: 4 }} />
                    Prérequis : <code>cd oracle-interface && npm run build</code>
                </p>
                <div className="dev-modal__actions">
                    <button type="button" onClick={onCancel} className="dev-btn">
                        Annuler
                    </button>
                    <button type="button" onClick={onConfirm} className="dev-btn dev-btn--primary">
                        Ouvrir la preview
                    </button>
                </div>
            </div>
        </div>
    );
}
